class BackpackGameForm {
  init() {
    const fieldsToShow = document.querySelectorAll('[data-field-show-if]');
    const fieldsToHide = document.querySelectorAll('[data-field-hide-if]');

    fieldsToShow.forEach((field) => this.addToggleEvent(field, 'show'));
    fieldsToHide.forEach((field) => this.addToggleEvent(field, 'hide'));
  }

  addToggleEvent(field, state) {
    const [name, type] = field
      .getAttribute(`data-field-${state}-if`)
      .split(':');
    const targetedField = document.querySelector(`[name=${name}]`);

    if (targetedField) {
      const toggleFieldCallback = () => {
        this.toggleField(field, state, type, targetedField.value);
      };

      targetedField.addEventListener('change', toggleFieldCallback);
      toggleFieldCallback();
    }
  }

  toggleField(field, state, type, value) {
    let shouldShow = state === 'show' ? type === value : type !== value;

    if (type.includes(',')) {
      const types = type.split(',');
      shouldShow =
        state === 'show' ? types.includes(value) : !types.includes(value);
    }
    field.style.display = shouldShow ? '' : 'none';
  }
}

export default new BackpackGameForm();
